import TestimonialCard from "../testimonial-card/testimonial-card";
import TestimonialData from "../../data/testimonials.json";
import "./testimonial-page.css";

export default function TestimonialPage() {
  const testimonialArr = TestimonialData;
  const length = testimonialArr.length -1;
  return (
    <>
      <h1 className="ae-testimonial-page-title">
        What people say about us
      </h1>
      {testimonialArr.map((testimonial: any, index: number) => {
        return (
          <div
            className="ae-testimonial-page-card-wrapper"
            key={testimonial.key}
          >
            <TestimonialCard
              name={testimonial.name}
              title={testimonial.title}
              quote={testimonial.quote}
              fromPage={true}
              index={index}
              length={length}
            />
          </div>
        );
      })}
    </>
  );
}
